<template>
  <div>
    <PromoterCardEdit :id="id" v-if="tipology == 'promoter'" />
    <AmbassadorCardEdit :id="id" v-else-if="tipology == 'ambassador'" />
    <div v-else class="title is-1">😓</div>
  </div>
</template>

<script>
import PromoterCardEdit from "@/components/Cards/Promoter/PromoterCardEdit";
import AmbassadorCardEdit from "@/components/Cards/Ambassador/AmbassadorCardEdit";

export default {
  components: {
    PromoterCardEdit,
    AmbassadorCardEdit,
  },
  data() {
    return { id: 0, tipology: null };
  },

  mounted() {
    this.id = this.$route.params.id;
    this.tipology = this.$route.params.tipology;
  },
};
</script>
